module.exports = __webpack_public_path__ + "static/media/circle-outline-svgrepo-com.d1e38d19.svg";